import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, Typography, Box
} from '@mui/material';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, LabelList
} from 'recharts';
import { Line } from 'recharts';
import axios from 'axios';
import { API_URL } from '../../api'; 
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


function KPI({ open, onClose }) {



    const handleClickBar = (data) => {
    if (!data?.label) return;

    const nomeMes = data.label.trim().toLowerCase();
    const indexMes = [
      'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
      'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
    ].indexOf(nomeMes);

    if (indexMes !== -1) {
      const mesFormatado = String(indexMes + 1).padStart(2, '0');
      setMes(mesFormatado);
    }
  };


  const [anoInicial, setAnoInicial] = useState('');
  const [anoFinal, setAnoFinal] = useState('');

  const [mes, setMes] = useState('');
  const [semana, setSemana] = useState('');

const anoBase = 2022;
const hoje = new Date();
const limite = new Date(hoje.getFullYear(), 0, 1); // 1º de janeiro do ano atual
const anoLimite = hoje >= limite ? hoje.getFullYear() : hoje.getFullYear() - 1;

const anosDisponiveis = Array.from({ length: anoLimite - anoBase + 1 }, (_, i) => anoBase + i);


  const mesesDisponiveis = Array.from({ length: 12 }, (_, i) => i + 1);
  const semanasDisponiveis = [1, 2, 3, 4, 5];



  const [dados, setDados] = useState({
    status: [],
    responsavel: [],
    cliente: [],
    mensal: []
  });

  useEffect(() => {
    console.log('✅ Componente KPI montado');
    if (!open) return;

    const query = new URLSearchParams();
    

const anoInicialNum = parseInt(anoInicial);
const anoFinalNum = parseInt(anoFinal);

if (!isNaN(anoInicialNum) && !isNaN(anoFinalNum)) {
  for (let a = anoInicialNum; a <= anoFinalNum; a++) {
    query.append('ano', a);
  }
} else if (!isNaN(anoInicialNum)) {
  query.append('ano', anoInicialNum);
} else if (!isNaN(anoFinalNum)) {
  query.append('ano', anoFinalNum);
}



    if (mes) query.append('mes', mes);
    if (semana) query.append('semana', semana);

    axios.get(`${API_URL}/gpd/indicadores?${query.toString()}`)
      .then(res => {
        setDados(res.data);
      })
      .catch(err => {
        console.error('Erro ao carregar indicadores:', err);
      });
  }, [open, anoInicial, anoFinal, mes, semana]);



function calcularComparacoes(data) {
  if (!Array.isArray(data) || data.length < 2) return data;

  const resultado = [...data];
  for (let i = 1; i < resultado.length; i++) {
    const atual = parseFloat(resultado[i].quantidade || 0);
    const anterior = parseFloat(resultado[i - 1].quantidade || 0);

if (anterior === 0 || anterior === null || atual === 0 || atual === null) {
  resultado[i].variacao = null;
} else {
  const diferenca = atual - anterior;
  const variacao = ((diferenca / anterior) * 100).toFixed(1);
  resultado[i].variacao = isFinite(variacao) ? parseFloat(variacao) : null;
}

  }

  return resultado;
}



function calcularComparacoesPorAno(agrupado) {
  const todasLabels = Array.from(
    new Set(Object.values(agrupado).flat().map(item => item.label))
  );
  const anos = Object.keys(agrupado).sort();
  const resultado = [];

  todasLabels.forEach(label => {
    let anterior = null;
    const item = { label };

    anos.forEach(ano => {
      const encontrado = agrupado[ano].find(x => x.label === label);
      const valor = encontrado?.quantidade || 0;
      item[ano] = valor;

      if (anterior !== null) {
const variacao = (anterior > 0 && valor > 0)
  ? (((valor - anterior) / anterior) * 100).toFixed(1)
  : null;

        item[`variacao_${ano}`] = isFinite(variacao) ? parseFloat(variacao) : null;
      }

      anterior = valor;
    });

    resultado.push(item);
  });

  return resultado;
}




const renderGrafico = (data, titulo, cor = '#1976d2') => {
  console.log('📊 DATA RECEBIDA:', titulo, data);
  if (!data || data.length === 0) return null;

  const temAno = data.some(d => d.hasOwnProperty('ano'));
  const rotuloVertical = titulo === 'Projetos por Cliente';

  const totalProjetos = ['Projetos por Status', 'Projetos por Mês'].includes(titulo)
    ? data.reduce((acc, cur) => acc + cur.quantidade, 0)
    : null;

  const cores = ['#1976d2', '#ff9800', '#4caf50', '#9c27b0'];

 if (temAno) {
  const agrupadoPorAno = {};
  data.forEach(({ label, quantidade, ano }) => {
    if (!agrupadoPorAno[ano]) agrupadoPorAno[ano] = [];
    agrupadoPorAno[ano].push({ label, quantidade });
  });

  const anosPresentes = Object.keys(agrupadoPorAno);
  const todasLabels = Array.from(new Set(data.map(d => d.label)));

  let dataTransformada;

  if (anosPresentes.length === 1) {
    const unicoAno = anosPresentes[0];
    const dataUnica = agrupadoPorAno[unicoAno];

    const ordemMeses = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    const dataOrdenada = dataUnica.sort((a, b) =>
      ordemMeses.indexOf(a.label) - ordemMeses.indexOf(b.label)
    );

    const dataComVariações = calcularComparacoes(dataOrdenada).map(item => ({
      label: item.label,
      [unicoAno]: item.quantidade,
      [`variacao_${unicoAno}`]: item.variacao,
    }));

    dataTransformada = dataComVariações;
  } else {
    dataTransformada = calcularComparacoesPorAno(agrupadoPorAno);
  }



    return (
      <Box data-chart={titulo} sx={{ height: rotuloVertical ? 500 : 450, my: 6, minWidth: 920 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>{titulo}</Typography>
        <ResponsiveContainer width="100%" height="100%">
          
          
          
          
          
          
          <BarChart
            data={dataTransformada}



            
            margin={{ top: 30, right: 30, left: 10, bottom: rotuloVertical ? 20 : 60 }}



            
          >
            <XAxis
              dataKey="label"
              angle={rotuloVertical ? -90 : 0}
              textAnchor={rotuloVertical ? 'end' : 'middle'}
              interval={0}
              height={rotuloVertical ? 120 : 40}
              tick={{ fontSize: 14, fontWeight: 'bold', fill: '#333' }}
            />
            <YAxis />
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 14, fontWeight: 'bold', paddingTop: 12 }} />

            {Object.keys(agrupadoPorAno).map((ano, i) => (
              <Bar key={ano} dataKey={ano} fill={cores[i % cores.length]}>
                


{titulo === 'Projetos por Mês' ? (
  <LabelList
    position="top"
    content={(props) => {
      const { x, y, width, height, value, index } = props;
      const item = dataTransformada[index] || {};
      const variacaoKey = `variacao_${ano}`;
      const variacao = item[variacaoKey];
      const textoVariacao =
        variacao != null && isFinite(variacao)
          ? `${variacao > 0 ? '+' : ''}${variacao}%`
          : null;

      return (
        <>
          <text
            x={x + width / 2}
            y={y - 6}
            textAnchor="middle"
            fontSize={13}
            fontWeight="bold"
            fill="#333"
          >
            {value}
          </text>
          {textoVariacao && (
            <text
              x={x + width / 2}
              y={y + height + 40}
              textAnchor="middle"
              fontSize={13}
              fontWeight="bold"
              fill={variacao > 0 ? 'green' : 'red'}
            >
              {textoVariacao}
            </text>
          )}
        </>
      );
    }}
  />
) : (
  <LabelList
    position="top"
    content={(props) => {
      const { x, y, width, value } = props;

      return (
        <text
          x={x + width / 2}
          y={y - 6}
          textAnchor="middle"
          fontSize={13}
          fontWeight="bold"
          fill="#333"
        >
          {value}
        </text>
      );
    }}
  />
)}



               <LabelList
  position="top"
  content={(props) => {
    const { x, y, width, value } = props;
    return (
      <text
        x={x + width / 2}
        y={props.y - 6}
        textAnchor="middle"
        fontSize={13}
        fontWeight="bold"
        fill="#333"
      >
        {value}
      </text>
    );
  }}
/>



              </Bar>
            ))}

            {/* LINHAS SOBREPOSTAS PARA CADA ANO */}
            {titulo === 'Projetos por Mês' &&
              Object.keys(agrupadoPorAno).map((ano, i) => (
                <Line
                  key={`line-${ano}`}
                  type="monotone"
                  dataKey={ano}
                  legendType="none"
                  stroke={cores[i % cores.length]}
                  strokeWidth={2}
                  dot={{ r: 2 }}
                  activeDot={{ r: 4 }}
                />
              ))}

          </BarChart>
        </ResponsiveContainer>
      </Box>
    );
  }

  // GRÁFICO SIMPLES (SEM ANO)
  let dadosOrdenados = [...data];
  if (['Projetos por Status', 'Projetos por Responsável P&D', 'Projetos por Cliente'].includes(titulo)) {
    dadosOrdenados.sort((a, b) => b.quantidade - a.quantidade);
  } else if (titulo === 'Projetos por Mês') {
    dadosOrdenados = data.map((item, index) => {
      const atual = item.quantidade;
      const anterior = index > 0 ? data[index - 1].quantidade : null;
     
     
      const variacao = (anterior && atual)
  ? (((atual - anterior) / anterior) * 100).toFixed(1)
  : null;


      return { ...item, variacao: isFinite(variacao) ? parseFloat(variacao) : null };
    });
  }

  const larguraPorItem = 80;
  const larguraMinima = 400;
  const chartWidth = Math.max(data.length * larguraPorItem, larguraMinima);

  return (
    <Box data-chart={titulo} sx={{ height: rotuloVertical ? 500 : 450, my: 6, pb: 8 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>{titulo}</Typography>
      {titulo === 'Projetos por Mês' && totalProjetos !== null && (
        <Typography sx={{ fontSize: 15, color: '#555', mb: 1 }}>
          Total de Projetos: <strong>{totalProjetos}</strong>
        </Typography>
      )}
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={chartWidth}
          height={rotuloVertical ? 500 : 450}
          data={dadosOrdenados}
          margin={{ top: 50, right: 30, left: 10, bottom: rotuloVertical ? 20 : 40 }}
        >
          <XAxis
            dataKey="label"
            angle={rotuloVertical ? -90 : 0}
            textAnchor={rotuloVertical ? 'end' : 'middle'}
            interval={0}
            height={rotuloVertical ? 120 : 40}
            tick={{ fontSize: 14, fontWeight: 'bold', fill: '#333' }}
          />
          <YAxis />
          <Tooltip />
          <Bar dataKey="quantidade" fill={cor}>
            <LabelList
              position="top"
              content={(props) => {
                const { x, y, width, height, value, index } = props;
                const item = dadosOrdenados[index] || {};
                const variacao = item.variacao;
                const textoVariacao =
                  variacao != null && isFinite(variacao)
                    ? `${variacao > 0 ? '+' : ''}${variacao}%`
                    : null;

                return (
                  <>
                    <text
                      x={x + width / 2}
                      y={y - 6}
                      textAnchor="middle"
                      fontSize={13}
                      fontWeight="bold"
                      fill="#333"
                    >
                      {value}
                    </text>
                    {textoVariacao && (
                      <text
                        x={x + width / 2}
                        y={y + height + 12}
                        textAnchor="middle"
                        fontSize={13}
                        fontWeight="bold"
                        fill={variacao > 0 ? 'green' : 'red'}
                      >
                        {textoVariacao}
                      </text>
                    )}
                  </>
                );
              }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};




  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle sx={{ fontWeight: 'bold' }}>
        Indicadores de Performance (KPI)
      </DialogTitle>
      <DialogContent>

        


<Box sx={{ textAlign: 'right', mb: 2 }}>
  <button onClick={exportarPDF} style={{




    background: '#1976d2',
    color: 'white',
    padding: '8px 16px',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    fontWeight: 'bold'
  }}>
    Exportar Gráficos em PDF
  </button>





</Box>



<Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
  <Box>
    

<Box sx={{ display: 'flex', gap: 1 }}>
  <Box>
    <Typography variant="body2">Ano</Typography>
    <select value={anoInicial} onChange={(e) => setAnoInicial(e.target.value)} style={{ padding: 6 }}>
      <option value="">Todos</option>
      {anosDisponiveis.map(a => (
        <option key={a} value={a}>{a}</option>
      ))}
    </select>
  </Box>

  <Box>
    <Typography variant="body2">até</Typography>
    <select value={anoFinal} onChange={(e) => setAnoFinal(e.target.value)} style={{ padding: 6 }}>
      <option value="">Todos</option>
      {anosDisponiveis.map(a => (
        <option key={a} value={a}>{a}</option>
      ))}
    </select>
  </Box>
</Box>



  </Box>

  <Box>
    <Typography variant="body2">Mês</Typography>
<select value={mes} onChange={(e) => setMes(e.target.value)} style={{ padding: 6 }}>
  <option value="">Todos</option>
  {[
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ].map((nome, index) => (
    <option key={index + 1} value={String(index + 1).padStart(2, '0')}>
      {nome}
    </option>
  ))}
</select>

  </Box>

  <Box>
    <Typography variant="body2">Semana</Typography>
    <select value={semana} onChange={(e) => setSemana(e.target.value)} style={{ padding: 6 }}>
      <option value="">Todas</option>
      {semanasDisponiveis.map(s => (
        <option key={s} value={s}>Semana {s}</option>
      ))}
    </select>
  </Box>
</Box>





        {renderGrafico(dados.mensal, 'Projetos por Mês', '#9c27b0')}
        {renderGrafico(dados.status, 'Projetos por Status', '#2196f3')}
        {renderGrafico(dados.responsavel, 'Projetos por Responsável P&D', '#4caf50')}
        {renderGrafico(dados.cliente, 'Projetos por Cliente', '#ff9800')}
        

        
      </DialogContent>
    </Dialog>
  );
}




const exportarPDF = async () => {
  const titulos = [
    'Projetos por Mês',
    'Projetos por Status',
    'Projetos por Responsável P&D',
    'Projetos por Cliente'
  ];

  const pdf = new jsPDF({ orientation: 'landscape', unit: 'px', format: 'a4' });

  const margem = 30;
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const maxWidth = pageWidth - margem * 2;
  const maxHeight = pageHeight - margem * 2;

  for (let i = 0; i < titulos.length; i++) {



    

    const titulo = titulos[i];
    const elemento = document.querySelector(`[data-chart="${titulo}"]`);
    if (!elemento) continue;

    // 🛠️ FORÇA ELEMENTO A MOSTRAR TUDO
    const originalWidth = elemento.style.width;
    const originalOverflow = elemento.style.overflow;
    const originalScroll = window.scrollX;

    elemento.style.width = elemento.scrollWidth + 'px';
    elemento.style.overflow = 'visible';

    // ⚠️ Scroll para o topo e zera scrollX antes da captura
    window.scrollTo(0, 0);

    // Medir o tamanho real do elemento com tudo renderizado (incluindo legenda)
    const bounding = elemento.getBoundingClientRect();
    const alturaReal = Math.max(bounding.height, elemento.scrollHeight) + 140; // aumenta mais para garantir legenda

    const canvas = await html2canvas(elemento, {
      backgroundColor: '#ffffff',
      scale: 2,
      scrollX: 0,
      scrollY: -window.scrollY,
      windowWidth: elemento.scrollWidth,
      windowHeight: alturaReal,
      useCORS: true
    });



    // 🔄 RESTAURA ESTILOS
    elemento.style.width = originalWidth;
    elemento.style.overflow = originalOverflow;
    window.scrollTo(originalScroll, 0);



    const imgData = canvas.toDataURL('image/png');
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;

    const ratio = Math.min(maxWidth / imgWidth, maxHeight / imgHeight);
    const finalWidth = imgWidth * ratio;
    const finalHeight = imgHeight * ratio;

    const posX = (pageWidth - finalWidth) / 2;
    const posY = (pageHeight - finalHeight) / 2; 


    if (i > 0) pdf.addPage();
    pdf.addImage(imgData, 'PNG', posX, posY, finalWidth, finalHeight);
  }

  pdf.save('graficos_kpi.pdf');
};






export default KPI;
